<template>

    <div class="modal fade" :id="'popUpSchedaProgetto' + rs" role="dialog" data-bs-backdrop="static">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0">
                    <h5 class="modal-title">
                        <i class="ph-list icon-modal-size me-2"></i><span class="me-2">Scheda:</span>{{ progetto?.TITOLO }}
                    </h5>
                    <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
                <div class="modal-body p-2" style="height: 33rem;">

                    <div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                    <div class="sidebar-content">
                                        <div class="card sidebar-section-body text-center p-2 mb-0">
                                            <div class="card-img-actions d-inline-block">
                                                <img v-if="progetto.ID_PROGETTO > 0 && progetto.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('PROGETTI',progetto.URL_AVATAR)" class="img-fluid squared-circle rounded-0" alt="" width="215" style="max-height: 230px;" />
                                                <span v-if="progetto.ID_PROGETTO == 0 || progetto.URL_AVATAR == 'placeholder.jpg'">
                                                    <img src="../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
                                                </span>
                                                <div class="card-img-actions-overlay card-img rounded-circle">
                                                    <a href="#" class="btn btn-outline-white btn-icon rounded-pill" v-on:click="uploadImmagineProgetto()"> <!--  v-if="$root.hasFunzionalita('PROGETTO_MODIFICA')" -->
                                                        <i class="ph-pencil"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <ul class="nav nav-sidebar" role="tablist">
                                            <li class="nav-item" role="presentation">
                                                <a href="#project" id="datiProgetto" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab" v-on:click="tabSelezionato = 'datiProgetto'" style="padding-left: 5px;" tabindex="1">
                                                    <i class="ph-megaphone me-1"></i>Dati Progetto
                                                </a>
                                            </li>
                                            <li class="nav-item" role="presentation" v-if="progetto.ID_PROGETTO > 0">
                                                <a href="#listeProgetto" id="listeProgettoTab" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato = 'listeProgetto'; $refs.tabListe.loadListeIds()" style="padding-left: 5px;" tabindex="2">
                                                    <i class="ph-list me-1"></i>Liste
                                                    <span class="badge bg-primary ms-1" v-if="$refs.tabListe && $refs.tabListe.listeAssociateIds.length > 0">{{ $refs.tabListe.listeAssociateIds.length }}</span>
                                                </a>
                                            </li>
                                            <li class="nav-item" role="presentation" v-if="progetto.ID_PROGETTO > 0">
                                                <a href="#modalitaPagamento" id="modalitaPagamentoTab" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato = 'modalitaPagamento'; $refs.tabModalitaPagamento.load()" style="padding-left: 5px;" tabindex="3">
                                                    <i class="ph-credit-card me-1"></i>Mod. Pagamento
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                
                                </div>
                                <div class="col-12 col-md-10 col-lg-10">
                                    <div class="tab-content flex-fill">
                                        <TabDatiProgetto
                                            :progetto="progetto"
                                            :utentiSelezionati="utentiSelezionati"
                                            :arrayStatiProgetto="arrayStatiProgetto"
                                            @update:progetto="progetto = $event"
                                            @update:utentiSelezionati="utentiSelezionati = $event" />

                                        <TabListe v-if="progetto.ID_PROGETTO > 0"
                                            :progetto="progetto"
                                            ref="tabListe"
                                            @updateGriglia="$emit('updateGriglia')" />


                                        <TabModalitaPagamento v-if="progetto.ID_PROGETTO > 0"
                                            :progetto="progetto"
                                            ref="tabModalitaPagamento" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
                    </button>
                    <button v-if="tabSelezionato == 'datiProgetto'" class="btn btn-secondary float-end" v-on:click="salvaProgetto()"><i class="fal fa-save fa-fw me-1"></i> Salva Modifiche</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpUploadImgProgetto'+rs" role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header modal-header-2 bg-light text-dark">
                    <h6 class="modal-title">Upload immagine Profilo</h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <Upload :args="argsProgetto" @onsuccess="successCaricamento($event)" @onerror="errorCaricamento($event)"></Upload>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-1"></i> Chiudi
                    </button>
                    <button class="btn btn-success float-end btn-sm" v-on:click="salvaFunzionalita()">
                        <i class="fal fa-save fa-fw me-1"></i> Salva Modifiche
                    </button>
                </div>
            </div>
        </div>
    </div>


</template>



<script>

import TabDatiProgetto from '@/components/TabDatiProgetto.vue'
import TabListe from '@/components/TabListe.vue'
import TabModalitaPagamento from '@/components/TabModalitaPagamento.vue' 
import Upload from '@/components/utils/Upload.vue'


export default {
    name: "SchedaProgetto",

    emits: ['updateGriglia', 'updateProgetto'],

    props: {
        statiProgetto: {
            type: Array,
            default: () => []
        }
    },

    components: {
        TabDatiProgetto,
        TabListe,
        TabModalitaPagamento,
        Upload,
    },

    data: function () {
        return {
            filters: global.filters,
            progetto: { ID_PROGETTO: 0, tipologie: new Array() },
            rs: utils.generateRandomString(30),
            tabSelezionato: "datiProgetto",
            utentiSelezionati: new Array(),
            argsProgetto: {},
            arrayStatiProgetto: new Array(),
            modalitaEsportazione: [
                { ID: 1005, LABEL: 'Multi-Foglio (Foglio per attività)' },
                { ID: 1007, LABEL: 'Foglio Unico (Tutte le attività)' }
            ]
        }
    },

    methods: {
        openSchedaProgetto: function (progetto) {
            this.tabSelezionato = "datiProgetto";
            this.progetto = utils.clone(progetto);

            if (!this.progetto.ID_PROGETTO || this.progetto.ID_PROGETTO == 0) {
                this.progetto.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
            }

            if (this.progetto.UTENTI_CONDIVISI && Array.isArray(this.progetto.UTENTI_CONDIVISI)) {
                this.utentiSelezionati = this.progetto.UTENTI_CONDIVISI
                    .map(u => u.ID_UTENTE)
                    .filter(id => id !== null && id !== undefined && id !== '');
            } else {
                this.utentiSelezionati = [];
            }

            this.filters.openPopUp('popUpSchedaProgetto' + this.rs);

            if (this.progetto.ID_PROGETTO > 0) {
                this.$nextTick(() => {
                    this.$refs.tabListe?.loadListeIds();
                    this.$refs.tabModalitaPagamento?.load();
                });
            }
        },

        salvaProgetto: function () {
            if (this.tabSelezionato == "datiProgetto" || this.tabSelezionato == "contenuti") {
                var api = this.progetto.ID_PROGETTO > 0 ? "theb/progetto/update" : "theb/progetto/insert";

                var payload = utils.clone(this.progetto);
                if (payload.DATA_EVENTO) {
                    payload.DATA_EVENTO = this.filters.formatDateReverse(payload.DATA_EVENTO);
                }
                // Filtra valori vuoti da utentiSelezionati
                payload.UTENTI_CONDIVISI = this.utentiSelezionati.filter(id => id !== null && id !== undefined && id !== '');

                utils.ajax(api, payload, (response) => {
                    if (response.esito == 0) {
                        if (this.progetto.ID_PROGETTO > 0) {
                            // Aggiorno il codice progetto dalla risposta
                            if (response.CODICE_PROGETTO) {
                                this.progetto.CODICE_PROGETTO = response.CODICE_PROGETTO;
                            }
                            // Ricarica il progetto per ottenere dati aggiornati
                            utils.ajax("theb/progetto", { ID_PROGETTO: this.progetto.ID_PROGETTO }, (data) => {
                                if (data.esito == 0 && data.data && data.data.length > 0) {
                                    this.progetto = utils.clone(data.data[0]);
                                    if (this.progetto.UTENTI_CONDIVISI && Array.isArray(this.progetto.UTENTI_CONDIVISI)) {
                                        this.utentiSelezionati = this.progetto.UTENTI_CONDIVISI
                                            .map(u => u.ID_UTENTE)
                                            .filter(id => id !== null && id !== undefined && id !== '');
                                    }
                                }
                            }, false, 0, "POST");
                            this.$emit('updateProgetto', this.progetto.ID_PROGETTO);
                        }
                        utils.alert.success(response.messaggio);
                        if (this.progetto.ID_PROGETTO == 0) {
                            this.progetto.ID_PROGETTO = response.id_inserito;
                            // Aggiorno il codice progetto dalla risposta
                            if (response.CODICE_PROGETTO) {
                                this.progetto.CODICE_PROGETTO = response.CODICE_PROGETTO;
                            }
                            this.$nextTick(() => {
                                this.$refs.tabModalitaPagamento?.load();
                            });
                        }
                        this.$emit("updateGriglia", response.data);
                    }
                });
            }
            else if (this.tabSelezionato == "configurazioni") {
                utils.ajax("travel/progetto/opzioni/update", { ID_PROGETTO: this.progetto.ID_PROGETTO, opzioni: this.arrayOpzioniProgetto, enti: this.progetto.enti }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.$emit("updateGriglia", response.data);
                    }
                });
            }
        },

        uploadImmagineProgetto: function () {
            this.filters.openPopUp("popUpUploadImgProgetto" + this.rs);
        },

        successCaricamento: function () {
            this.filters.closePopUp("popUpUploadImgProgetto" + this.rs);
            utils.ajax("travel/progetto", { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                this.progetto = response.data.UTENTE;
                this.$emit("updateGriglia", response.data);
            });
        },

        errorCaricamento: function () {
            this.filters.closePopUp("popUpUploadImgProgetto" + this.rs);
        },
    },

    watch: {
        'progetto.FK_ID_UTENTE'(newAccountEvento) {
            if (newAccountEvento) {
                const index = this.utentiSelezionati.indexOf(newAccountEvento);
                if (index > -1) {
                    this.utentiSelezionati.splice(index, 1);
                }
            }
        },
        statiProgetto: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.arrayStatiProgetto = newVal;
                }
            },
            immediate: false
        }
    },

    created: function () {
        this.arrayEnti = this.filters.toSelect2(this.$root.arrayEnti, 'ID_ENTE', 'LABEL');

        if (this.statiProgetto && this.statiProgetto.length > 0) {
            this.arrayStatiProgetto = this.statiProgetto;
        }
    },

}
</script>
